import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-amount-page-ui',
    templateUrl: './bb-amount-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AmountPageComponent {}
